import React from "react";
import classNames from 'classnames';
 
import {connect} from 'react-redux';   
import {fetchOrderData,fetchOrderListing} from '../../redux/actions/orderAction'
import {ROWS_PER_PAGE} from '../../AppConfig'

class OrderSearchPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            // email:"",
            cust: "",
            orderIdentifier: "",
            searchString: "",
            storeId: window.sessionStorage.getItem('storeId'),
            storeClerkToken : window.sessionStorage.getItem('storeClerkToken'), 
            errorMsg: "" ,
            firstName:"",
            lastName:"",
            billingEmail:"",
            rowsPerPage:ROWS_PER_PAGE,
            activePage:1,
            loader:false
         } 
        this.handleChange = this.handleChange.bind(this);
        this.getOrderData = this.getOrderData.bind(this);
        this.getOrderListData = this.getOrderListData.bind(this);
    }  

    handleChange(e) {
        let { name, value } = e.target;
        this.setState({ [name]: value });
    }  

    //update the state value once clicked the find order button
    componentWillReceiveProps(nextProps){
        let errorMessage;

        if(nextProps.orderDetails)
            errorMessage = nextProps.orderDetails.errorMessage;

        if(nextProps.orderListing && this.state.storeClerkToken)
            errorMessage = nextProps.orderListing.errorMessage;

        this.setState({
            errorMsg: errorMessage,
            // email: nextProps.email,
            searchString: nextProps.searchString,
            orderIdentifier: nextProps.orderIdentifier
        });      
    }

    //Get Order details data
    getOrderData(e) {         
        e.preventDefault();
        this.setState({
            errorMsg: ''
        });
        if(Object.entries(this.props.policyData.returnSettingsMap).length <=0){
            this.setState({
                errorMsg: 'We’re sorry, we are unable to process your return at this time.  Please call the number on your order details for assistance.'
            });
            return false;
        }
         const { searchString } = this.state
         if (!searchString) {
             this.setState({
                 errorMsg: 'Please provide any of the following information: "Email" or "Phone Number"'
             });
             return false
         }

       let CustomerData= {"orderIdentifier" : this.state.orderIdentifier.split(':')[0].split("-", 2).join("-"),"searchString" : this.state.searchString,
                           "storeId":this.state.storeId };
        this.props.fetchOrderData(CustomerData,this.props);  
    } 

    // fetch order listing for store clerk
    async getOrderListData(e){
        e.preventDefault();
        this.setState({
            errorMsg: '',
            loader: true
        });
        if(Object.entries(this.props.policyData.returnSettingsMap).length <=0){
            this.setState({
                errorMsg: 'We’re sorry, we are unable to process your return at this time.  Please call the number on your order details for assistance.'
            });
            return false;
         }
       if(this.state.firstName.trim() === '' && this.state.lastName.trim() === ''&&
          this.state.billingEmail.trim() === '' && this.state.orderIdentifier.trim() === '' ){
            this.setState({
                errorMsg: 'Please enter at least one search option and try again'
            }); 
          }
        else{
            let orderSearchInputForClerk ={
                            "firstName":this.state.firstName.trim(),
                            "lastName" :this.state.lastName.trim(),
                            "emailAddress" : this.state.billingEmail.trim(),
                            "orderIdentifier":this.state.orderIdentifier.trim(), 
                            "storeId": this.state.storeId,
                            "storeClerkToken":this.state.storeClerkToken,
                            "activePage":this.state.activePage,
                            "rowsPerPage":this.state.rowsPerPage
                          }
                        
            await this.props.fetchOrderListing(orderSearchInputForClerk,this.props);
           }
            this.setState({
                loader: false
            });
        } 


    render() {
        
        let inputClasses = classNames({
            'form-control' : true,'input-ctrl': true,'is-invalid':this.state.errorMsg?true:false
         });

        return ( 
                <React.Fragment>
                    {this.state.loader &&
                        <div className="loading">Loading&#8230;</div>
                    }
                    <div className="row">
                        <div className="col-sm-6 order-2 order-sm-1 pt-4">
                            {this.props.policyData.returnSettingsMap && this.props.policyData.errorMessage===undefined ?
                                <div dangerouslySetInnerHTML={{ __html: this.props.policyData.returnSettingsMap.fullReturnPolicyText}} />
                                :
                                <div className="error" >{this.props.policyData.errorMessage}</div>
                            }
                        </div>
                        <div className="col-sm-6 order-1 order-sm-2 pt-4">
                            <div className="form-sections">
                                <div className="sub-title">SEARCH FOR ORDER</div>
                          
                           {/* set Order search input based on user */}
                                {this.state.storeClerkToken ===null ? 
                                // order search input for shopify customer
                                <form name='form' onSubmit={this.getOrderData}>
                                    <div className="form-group">
                                        <label className="required">Email Address or Phone Number</label>
                                        <input type="text"  className={inputClasses} name='searchString' value={this.state.searchString} onChange={this.handleChange}  required/>
                                        <span className="hint">Email Address or Phone number used when order was placed</span>
                                    </div>
                                    <div className="form-group">
                                        <label className="required">Order Number or Return Number</label>
                                        <input type="text"  className={inputClasses} name='orderIdentifier' value={this.state.orderIdentifier} onChange={this.handleChange} required />
                                        { this.props.policyData.storeOrderExample &&  <span className="hint">Example: {this.props.policyData.storeOrderExample}</span>}
                                    </div>
                                    {this.state.errorMsg &&
                                        <div id="error" className="float-right error">  
                                            {this.state.errorMsg}                           
                                        </div>
                                    }
                                    <br></br>
                                    <div className="float-right">
                                        <button type="submit" className="btn btn-primary btn-new">FIND ORDER</button>
                                    </div>
                                </form>
                                :
                            //   order search input for store clerk 
                                <form name='form' onSubmit={this.getOrderListData}>
                                <div className="form-group ">
                                    <label >Customer First Name</label>
                                    <input type="text" className={inputClasses} name='firstName' value={this.state.firstName} onChange={this.handleChange}  />
                                </div>
                                <div className="form-group">
                                    <label >Customer Last Name</label>
                                    <input type="text"  className={inputClasses} name='lastName' value={this.state.lastName}  onChange={this.handleChange}  />
                                </div>
                                <div className="form-group">
                                    <label>Customer Email</label>
                                    <input type="email"  className={inputClasses} name='billingEmail' value={this.state.billingEmail}  onChange={this.handleChange}  />
                                </div>
                                <div className="form-group">
                                    <label >Order Number or Return Number</label>
                                    <input type="text"  className={inputClasses} name='orderIdentifier' value={this.state.orderIdentifier}  onChange={this.handleChange}  />
                                </div>
                                {this.state.errorMsg &&
                                    <div id="error" className="float-right error">  
                                        {this.state.errorMsg}                           
                                    </div>
                                }
                                <br></br>
                                <div className="float-right">
                                    <button type="submit" className="btn btn-primary btn-new">FIND ORDER</button>
                                </div>
                            </form>
                            }
                            </div>
                        </div> 
                    </div>
                    <div className="img-container">
                       <a href="https://nogin.com" target="_blank">
                         <img src="/returns/img/NOGIN-PoweredBy.png" alt="Powered by Nogin" width="240px"/>
                       </a>
                    </div>
                </React.Fragment>   
        );
    }

}
 
  
  const mapStateToProps = (state) =>({
    policyData: state.storeSettingData.storeDesign,
    orderDetails: state.orderDataDetails.orderData,
    // email: state.orderDataDetails.email,
    searchString: state.orderDataDetails.searchString,
    orderIdentifier: state.orderDataDetails.orderIdentifier,
    orderListing: state.orderDataDetails.orderListing
  });
  
  export default connect(mapStateToProps,{fetchOrderData,fetchOrderListing})(OrderSearchPage);
 



// WEBPACK FOOTER //
// ./src/components/OrderSearch/OrderSearchPage.js